export default "__VITE_ASSET__Zzt_gtNq__"